// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export enum ChangeFeedMode {
  LatestVersion = "Incremental Feed",
  AllVersionsAndDeletes = "Full-Fidelity Feed",
}
